import {
    ConditionParams,
    ProductConfiguration
} from "@omni/types/utils/productConfiguration";

import { encodePaintConfiguratorUrlState } from "@/components/PaintConfigurator/helpers/state.helper";
import { CalculatorConfigs } from "@/utils/productConfiguration/visuals/calculator/calculator.config";
import { LicensePlateCondition } from "@/utils/productConfiguration/visuals/licensePlate/licensePlate.config";
import { PaintConfiguratorCondition } from "@/utils/productConfiguration/visuals/paintConfiguration/paintConfigurator.config";

import LicensePlate from "./visuals/licensePlate/licensePlate.component";
import {
    LicensePlateConfiguration,
    LicensePlateSubmitModel
} from "./visuals/licensePlate/licensePlate.types";
import { PaintConfigurator } from "./visuals/paintConfiguration/paintConfigurator.component";
import {
    PaintConfigurationEditUrlConfig,
    PaintConfigurationSubmitModel,
    PaintConfigurationUrlState
} from "./visuals/paintConfiguration/paintConfigurator.types";

export const productConfigurations: ProductConfiguration[] = [
    {
        condition: LicensePlateCondition,
        visual: LicensePlate,
        productSubType: "licenseplates",
        configPaths: ["chosenLicensePlateType", "chosenLicensePlateText"],
        dataPaths: (config) => config,
        previewPath: "chosenLicensePlateText",
        withOrigin: true
    } satisfies ProductConfiguration<
        LicensePlateConfiguration,
        LicensePlateSubmitModel
    >,
    {
        condition: PaintConfiguratorCondition,
        visual: PaintConfigurator,
        productSubType: "paints",
        configPaths: [
            "paintInfo.colorHex",
            "paintInfo.colorName",
            "paintInfo.colorId"
        ],
        dataPaths: (config) => ({
            chosenColorId: config.paintInfo.colorId
        }),
        previewPath: "paintInfo.colorName",
        editUrl: (config) => {
            const encodedUrlState = encodePaintConfiguratorUrlState(
                config.colorId,
                config.colorHex,
                config.colorName
            );
            return `${config.paintConfiguratorPath}?pc=${encodedUrlState}`;
        },
        withOrigin: false
    } satisfies ProductConfiguration<
        PaintConfigurationUrlState,
        PaintConfigurationSubmitModel,
        PaintConfigurationEditUrlConfig
    >,
    ...CalculatorConfigs
];

export const getProductConfiguration = (
    params: ConditionParams
): ProductConfiguration | undefined => {
    return productConfigurations.find(({ condition }) => condition(params));
};

export const isConfigurableProduct = (params: ConditionParams): boolean =>
    productConfigurations.some(({ condition }) => condition(params));
